// extracted by mini-css-extract-plugin
export var label = "newsletter-field-module--label--ff47a";